import { ui } from '../ui';
import { colors } from '../theme';

/** Статус "Открытым Текстом" — только факт ответа, без варианта (см. app/services/quiz.py
 * на бэкенде: выбранный вариант физически не приходит в этот эндпоинт). */
export default function QuestionnaireBlock({ questionnaire }) {
  return (
    <div style={ui.card}>
      <div style={{ fontWeight: 600, marginBottom: 12 }}>Открытым Текстом</div>
      {questionnaire.length === 0 ? (
        <div style={ui.empty}>Вопросов пока не создано</div>
      ) : (
        questionnaire.map(q => (
          <div key={q.question_id} style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12,
            padding: '8px 0', borderBottom: `1px solid ${colors.border}`, fontSize: 14,
          }}>
            <span>{q.text}</span>
            <span style={ui.badge(...(q.answered ? ['#1c3a2a', colors.good] : [colors.surface2, colors.textMuted]))}>
              {q.answered ? 'Ответил(а)' : 'Не ответил(а)'}
            </span>
          </div>
        ))
      )}
    </div>
  );
}
